module.exports = __webpack_public_path__ + "img/palette-fill.46e26878.svg";